import { render, staticRenderFns } from "./dxReportViewer.vue?vue&type=template&id=05e056ba"
import script from "./dxReportViewer.ts?vue&type=script&lang=js&external"
export * from "./dxReportViewer.ts?vue&type=script&lang=js&external"
import style0 from "./dxReportViewer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports